

exports.__esModule = true;

require('jquery');

require('angularPlaceHolderShim');

require('js/lib/index');

require('xo-tracking/dist/index');

var _index = require('squid/index');

var _middleware = require('js/lib/middleware');

require('pages/xo-landing/route');

require('pages/xo-login/route');

require('pages/xo-review/route');

require('pages/xo-end/route');

require('./directive');

exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',
    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,
    children: [{
        name: '$LandingRoute'
    }, {
        name: '$LoginRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$PayWithSelectionRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-pay-with-selection/route');
        },
        slug: 'payWithSelection'
    }, {
        name: '$VenmoRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-venmo/route');
        },
        slug: 'venmo'
    }, {
        name: '$VenmoAuthRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-venmoAuth/route');
        },
        slug: 'venmoAuth'
    }, {
        name: '$ThirdPartyWalletFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-third-party-wallet/route');
        },
        slug: 'thirdPartyWalletFlow'
    }, {
        name: '$ThirdPartyInfoCollectFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-third-party-info/route');
        },
        slug: 'thirdPartyInfoCollectFlow'
    }, {
        name: '$GenericErrorRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-generic-error/route');
        },
        slug: 'genericError'
    }, {
        name: '$ChooseCreditOfferRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('xo-credit-components/src/choose-credit-offer/route');
        },
        slug: 'chooseCreditOffer'
    }, {
        name: '$RedirectToCapeRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('xo-credit-components/src/redirect-to-cape/route');
        },
        slug: 'redirectToCape'
    }, {
        name: '$GenericMessageRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-generic-message/route');
        },
        slug: 'genericMessage'
    }, {
        name: '$FullpageOnetouchUpsellRoute',
        lazyRoute: function lazyRoute() {
            return import('xo-login-components/src/fullpage-onetouch-upsell/route');
        },
        slug: 'FullpageOnetouchUpsell'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('xo-login-components/src/onetouch-interstitial/route');
        },
        slug: 'oneTouchUpsell'
    }, {
        name: '$SelectFiRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-select-fi/route');
        },
        slug: 'selectFi'
    }, {
        name: '$ReviewRoute'
    }, {
        name: '$AuthorizationMessageRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-authorization-message/route');
        },
        slug: 'authorizationmessage'
    }, {
        name: '$AddPhoneRoute',
        lazyRoute: function lazyRoute() {
            return import('xo-form-components/src/phone/route');
        },
        slug: 'addPhone'
    }, {
        name: '$AddCardPageRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-add-card/route');
        },
        slug: 'pageAddCard'
    }, {
        name: '$AddFiPageRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-add-fi/route');
        },
        slug: 'pageAddFi'
    }, {
        name: '$xoTokenizationInfoPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-tokenization-info/route');
        },
        slug: 'tokenizationInfo'
    }, {
        name: '$xoPinSetupPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-pin-setup/route');
        },
        slug: 'pinSetup'
    }, {
        name: '$AddCardMeftRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-add-card-meft/route');
        },
        slug: 'pageAddCardMeft'
    }, {
        name: '$AddTaxIdRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-add-tax-id/route');
        },
        slug: 'addTaxId'
    }, {
        name: '$TravelRuleRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-travel-rule/route');
        },
        slug: 'travelRule'
    }, {
        name: '$AddNationalIdRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-add-national-id/route');
        },
        slug: 'addNationalId'
    }, {
        name: '$UpdateCardPageRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-update-card/route');
        },
        slug: 'updateCard'
    }, {
        name: '$AddShippingPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-add-shipping/route');
        },
        slug: 'pageAddShipping'
    }, {
        name: '$xoSoldOutPageRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-inventory-soldout/route');
        },
        slug: 'soldout'
    }, {
        name: '$xoEConsentPageRoute',
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                success: function success() {
                    return _this.goto('this.review');
                }
            };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-eConsent/route');
        },
        slug: 'econsent'

    }, {
        name: '$xoNbrDEPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-nbr/route');
        },
        slug: 'negativeBalanceRecovery'

    }, {
        name: '$xoFrameBustRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-framebust/route');
        },
        slug: 'framebust'
    }, {
        name: '$SepaPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return import('pages/xo-sepa/route');
        },
        slug: 'sepapage'
    }, {
        name: '$PayRoute',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-pay/route');
        },
        slug: 'pay'
    }, {
        name: '$EndRoute',
        slug: 'end'
    }, {
        name: '$xoDeGuest',
        lazyRoute: function lazyRoute() {
            return import('pages/xo-de-guest/route');
        },
        slug: 'xoDeGuest'
    }, {
        name: '$BMLDisplay',
        attributes: {
            'review-url': 'reviewUrl'
        },
        lazyRoute: function lazyRoute() {
            return import('xo-credit-components/src/bml-display/route');
        },
        slug: 'bmldisplay'
    }, {
        name: '$DoneRoute',
        lazyRoute: function lazyRoute() {
            return import('xo-page-components/src/done/route');
        },
        slug: 'done'
    }, {
        name: '$xoPageCreatePasswordRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-create-password/route');
        },
        slug: 'createPassword'
    }, {
        name: '$xoCIPVerficationPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return import('pages/xo-cip-verification/route');
        },
        slug: 'cipverification'

    }]
});


_index.$Route;

_middleware.$Middleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/route.js
// module id = ./pages/xo-checkout/route.js
// module chunks = main-code-split